import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../contexts/AuthContext";

const useCelebration = (pageKey) => {
  const [winnersData, setWinnersData] = useState(null);
  const [showCelebration, setShowCelebration] = useState(false);

  useEffect(() => {
    const check = async () => {
      try {
        const configRes = await axios.get(`${API}/app-config`);
        if (configRes.data?.winners_announced) {
          const storageKey = `apl_celebration_seen_${pageKey}`;
          if (!localStorage.getItem(storageKey)) {
            const winnersRes = await axios.get(`${API}/winners`);
            if (winnersRes.data) {
              setWinnersData(winnersRes.data);
              setShowCelebration(true);
            }
          }
        }
      } catch (e) { /* silent */ }
    };
    check();
  }, [pageKey]);

  const dismissCelebration = () => {
    localStorage.setItem(`apl_celebration_seen_${pageKey}`, "true");
    setShowCelebration(false);
  };

  return { winnersData, showCelebration, dismissCelebration };
};

export default useCelebration;
